import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import axios from "axios";
import { apiVariable } from "../../../api/apiVariable";
import { Button } from "@mui/material";
import GenericFormPopup from "../GenericFormPopup/GenericFormPopup";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";
import { formatDate } from "../../../helpers/formatingFunctions";
import { maintenanceHistoryFieldConfiguration } from "../../../formConfigs/Fleet/maintenanceHistoryFieldConfig";

const UpdateMaintenanceHistoryPopup = ({ history }: { history: any }) => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [initialValues, setInitialValues] = useState<any>(null);

  const queryClient = useQueryClient();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setInitialValues(null);
  };
  const handleSnackbarClose = () => setStatus("idle");
  const { token } = useAuth();

  useEffect(() => {
    if (open) {
      setInitialValues({
        id: history.id,
        dateFullfilled: formatDate(history.dateFullfilled),
        mileage: history.mileage,
        engineHours: history.engineHours,
        notes: history.notes,
      });
    }
  }, [open]);

  const mutation = useMutation({
    mutationFn: (data: any) =>
      axios.put(`${apiVariable}/updateMaintenanceHistory`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          ContentType: "application/json",
        },
      }),
    onSuccess: () => {
      setStatus("success");

      queryClient.invalidateQueries({
        queryKey: ["assetMaintenanceOperationHistories"],
      });
      handleClose();
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response.data || "Failed to submit truck");
    },
  });

  const submitHandler = (data: any) => {
    const dateParts = data.dateFullfilled.split("/");
    const month = parseInt(dateParts[0], 10) - 1;
    const day = parseInt(dateParts[1], 10);
    const year = parseInt(dateParts[2], 10);

    const utcDate = new Date(Date.UTC(year, month, day));

    data.dateFullfilled = utcDate;
    mutation.mutate(data);
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        sx={{ mb: 1 }}
      >
        Update
      </Button>
      {open && initialValues && (
        <GenericFormPopup
          formFields={maintenanceHistoryFieldConfiguration}
          initialValues={initialValues}
          title="Update Maintenance History"
          onSubmit={submitHandler}
          open={open}
          onClose={handleClose}
          loading={mutation.isPending}
        />
      )}

      <StatusSnackbar
        status={status}
        successMessage={"Maintenance History updated successfully"}
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default UpdateMaintenanceHistoryPopup;
